<template>
  <div class="card raised">
    <div class="card-body">
      <h5 class="card-title"><a href="#nuk" v-on:click="playItem">{{this.item.name}}</a></h5>
      <!-- <button v-on:click="playItem" class="btn btn-round btn-primary">Play</button> -->
    </div>
  </div>
</template>
<script>
  export default {
    name: 'streamCard',
    props: {
      itemIndex: Number,
      item: Object,
    },
    mounted() {
      //console.log(this.item)
    },
    computed: {
    },
    methods: {
      playItem() {
        this.$store.dispatch('playStream', [this.itemIndex])
      }
    },

  }
</script>
<style>
</style>
